import {
  getApiErrorBodyFromUnknownError,
  isNonGlobalApiError,
} from "@/features/error/handleError";

/**
 * Whether `GlobalErrorHint` will already put this error on screen.
 *
 * The api-key modals use it to decide whether they still have anything to say.
 * Now that the four `OPENAPI_*` codes are in `ErrorSchema` and mapped to a
 * message, a rejection carrying one of them raises a snackbar on its own, and a
 * box in the modal saying the same thing is a second copy of it.
 *
 * What is left over is the case interlude answers without a code at all: the
 * name validators on `ApiKeyCreateIn` and `ApiKeyPatchIn` raise pydantic
 * `ValueError`s, which come back as a 422 whose body `ErrorSchema` cannot
 * parse. `getApiErrorBodyFromUnknownError` returns null for it, nothing global
 * appears, and the modal is the only place that can say so -- next to the field
 * that caused it.
 */
export function isHandledGlobally(error: unknown): boolean {
  const body = getApiErrorBodyFromUnknownError(error);
  if (!body) return false;
  // A code mapped to `null` is one a page is expected to answer for itself, so
  // it is not "handled" in the sense this asks about.
  return !isNonGlobalApiError(body.code);
}
